import { useEffect, useRef } from "react";
import { SECTIONS, App as DiscussitApp } from "@tree-company/discussit-embed";

const BEFORE_SECTION_CHANGE = "discussit:before-section-change";
const BEFORE_PREVIOUS_SECTION = "discussit:before-previous-section";

export function DiscussitFlow({ discussit, onCancel }) {
  const embedRef = useRef(null);

  useEffect(() => {
    const embed = embedRef.current;

    // Cancelling leaves the flow on the section it stood on, so the visitor
    // finds it as they left it when they come back to it.
    function cancelResults(event) {
      if (event.detail.nextSectionId !== SECTIONS.RESULTS) return;

      event.preventDefault();
      onCancel();
    }

    function cancelBackWithoutPrevious(event) {
      if (event.detail.previousSectionId !== null) return;

      event.preventDefault();
      onCancel();
    }

    embed.addEventListener(BEFORE_SECTION_CHANGE, cancelResults);
    embed.addEventListener(BEFORE_PREVIOUS_SECTION, cancelBackWithoutPrevious);
    return () => {
      embed.removeEventListener(BEFORE_SECTION_CHANGE, cancelResults);
      embed.removeEventListener(
        BEFORE_PREVIOUS_SECTION,
        cancelBackWithoutPrevious,
      );
    };
  }, [onCancel]);

  return (
    <div ref={embedRef} className="discussit-flow">
      {discussit && (
        <>
          {discussit.config.custom_css && (
            <style>{discussit.config.custom_css}</style>
          )}
          <DiscussitApp
            key={discussit.pass}
            config={discussit.config}
            state={discussit.state}
            translations={discussit.translations}
            hideFooter={true}
          />
        </>
      )}
    </div>
  );
}
